import { PaginationType } from '@api';
import { FileRoutesByFullPath } from '@providers';
import { UseNavigateResult } from '@tanstack/react-router';
import { useTablePagination, useTableSearch, useTableSorting } from './hooks';

type DefaultValuesType = {
  accessorOptions?: string[];
  defaultAccessor?: string;
  defaultDirection?: 'asc' | 'desc';
  pageSizeOptions?: number[];
};

type UseManageTableOptionsType = {
  navigateFn: UseNavigateResult<keyof FileRoutesByFullPath>;
  searchParams: Record<string, unknown>;
  pagination?: PaginationType;
  config: DefaultValuesType;
  tableId?: string;
};

type TableArgumentsType = {
  sorting: ReturnType<typeof useTableSorting>;
  pagination: ReturnType<typeof useTablePagination>;
  search: {
    setSearchValue: (value: string) => void;
    searchValue: string | undefined;
  };
};

export type UseManageTableReturnType = {
  tableArguments: TableArgumentsType;
};

export const useManageTable = ({
  navigateFn,
  searchParams,
  pagination,
  config,
  tableId,
}: UseManageTableOptionsType): UseManageTableReturnType => {
  const sorting = useTableSorting({
    navigateFn,
    searchParams,
    config,
    tableId,
  });

  const paginationController = useTablePagination({
    navigateFn,
    search: searchParams,
    pagination,
    config,
    tableId,
  });

  const search = useTableSearch({
    searchParams: searchParams,
    navigateFn,
    tableId,
  });

  const tableArguments = {
    sorting,
    pagination: paginationController,
    search,
  };

  return { tableArguments };
};
